import Cookies from 'js-cookie'
import {
  ErrorData,
  ErrorResponse,
  ResponseData,
  SuccessResponse
} from '../types/serviceTypes'

const API_URL: string = import.meta.env.VITE_API_URL as string

async function fetchRequest<T>(
  url: string,
  params: Record<string, unknown>,
  isAuth = true,
  method = 'GET'
): Promise<ResponseData<T>> {
  const jwt = isAuth ? Cookies.get('jwt') : undefined
  try {
    const options: RequestInit = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(isAuth ? { 'X-Auth-Token': jwt! } : {})
      }
    }

    if (Object.keys(params).length) {
      if (method === 'GET') {
        url += '?' + objectToQueryString(params)
      } else {
        options.body = JSON.stringify(params) // body should match Content-Type in headers option
      }
    }

    const response = await fetch(API_URL + '/api' + url, options)
    let result: unknown
    try {
      result = await response.json()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      result = {}
    }

    if (response.status >= 200 && response.status < 300) {
      return {
        data: result as T,
        status: response.status,
        success: true
      } as SuccessResponse<T>
    }

    return {
      data: result as ErrorData,
      status: response.status,
      success: false
    } as ErrorResponse
  } catch (error) {
    console.error(error)
    return {
      data: error as ErrorData,
      status: 500,
      success: false
    } as ErrorResponse
  }
}

function objectToQueryString(obj: Record<string, unknown>): string {
  return Object.keys(obj)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key] as string))
    .join('&')
}

async function fetchMultiPart(url: string, formData: FormData) {
  const jwt = Cookies.get('jwt')
  try {
    const options: RequestInit = {
      method: 'POST',
      body: formData,
      headers: {
        // 'Content-Type': 'multipart/form-data', // we will be sending JSON
        'X-Auth-Token': jwt!
      }
    }

    const response = await fetch(API_URL + url, options)

    const result = await response.json()

    return {
      data: result,
      status: response.status
    }
  } catch (error) {
    //   return generateErrorResponse(result.message)
    console.error(error)
    return {
      data: error,
      status: 500
    }
  }
}


export default fetchRequest 
export {fetchMultiPart}
